import {z} from 'zod'
import axios from '@/axiosInstance.ts'

export const HttpSubmitTicketParams = z.object({
    entityId: z.coerce.number().int().optional(),
    shootMediaId: z.string().optional(),
    data: z.object({
        message: z.string().optional(),
        subject: z.string().optional(),
        flow: z.string().optional(),
        recap: z.string()
    })
})
export type HttpSubmitTicketParams = z.infer<typeof HttpSubmitTicketParams>
export const httpSubmitTicket = (params: HttpSubmitTicketParams) => {
    const url = '/chatbot/entities/open-ticket'
    return axios.post(url, params.data, {
        params: {
            ...(params.entityId && {entity_id: params.entityId}),
            ...(params.shootMediaId && {task_media_id: params.shootMediaId})
        }
    })
}
